import React, { useEffect, useState } from "react";
import { formatNumber } from "../../../../services";
import styles from "./MyAdsFilter.scss";
import { Button, Col, Row } from "antd";

function MyAdsFilter(props: any) {
  const {
    ads,
    filters,
    statistic,
    onTabChange,
    status
  } = props;

  const [selectedMenu, setSelectedMenu] = useState(0);

  useEffect(() => {
    if (status == undefined) {
      setSelectedMenu(5);
    } else {
      setSelectedMenu(status + 1);
    }
  }, [status]);

  return (
    <section className={styles.filterSection}>
      <div className={styles.count}>{`${"Broj oglasa"}: ${formatNumber(
        ads.count
      )}`}</div>

      <Row className={styles.row} gutter={3} type="flex">
        {filters &&
          filters.map((filter: any, index: number) => (
            // The Menu would not show the first selected menu item if the key
            // starts with 0, so we need to increment it to 1 because the
            // initial first value of the "filter.value" is 0.
            <Col key={filter.value + 1} className={styles.menuItem}>
              {/* Key of the expired ad is 6 but the index in the list is 4 */}
              <Button
                type={selectedMenu == filter.value + 1 ?
                  "primary" : "default"}
                onClick={() => {
                  onTabChange(filter.value + 1);
                }}
                className={
                  selectedMenu == filter.value + 1
                    ? styles.active
                    : styles.inactive
                }
              >
                {filter.name}
              </Button>
            </Col>
          ))}
      </Row>
    </section>
  );
}

export default MyAdsFilter;



// WEBPACK FOOTER //
// ./src/containers/MyAdsPage/MyAds/MyAdsFilter/MyAdsFilter.tsx